import { useEffect, useState } from "react";

import { Button, SortDropdownValue } from "@/modules/common/components";
import { useFilters } from "@/modules/common/filters";
import { AdminUserRole, AdminUserSortField } from "@/modules/common/types/Users.enum";
import { PlusIcon } from "lucide-react";
import useUsersTotalizers from "./hooks/useUsersTotalizers";
import useUsersList from "./hooks/useUsersList";
import UsersTotalizers from "./components/UsersTotalizers";
import UsersFilterBar from "./components/UsersFilterBar";
import UsersList from "./components/UsersList";
import { ADMIN_USER_FILTER_FIELDS } from "./constants/AdminUserFilterFields";
import { ListAdminUsersDto } from "@/service/dto/admin-users";
import { FILTER_KEYS } from "@/modules/common/filters/keys";
import { usePagination } from "@/modules/common/hooks/usePagination";
import { ROUTES } from "@/routes/constants/routes";
import { useSessionStore } from "@/modules/auth/store/useSessionStore";

const Users = () => {
  const { canUserSee } = useSessionStore();

  const { data: totalizers, isLoading: isTotalizersLoading } = useUsersTotalizers();

  const [sort, setSort] = useState<SortDropdownValue<AdminUserSortField> | null>(null);

  const filters = useFilters<ListAdminUsersDto>({
    fields: ADMIN_USER_FILTER_FIELDS,
    filterKey: FILTER_KEYS.ADMIN_USERS,
  });

  const { page, setPage, limit, setPageSize } = usePagination();

  const filtersKey = JSON.stringify(filters.queryParams);
  const sortKey = sort ? `${sort.field}:${sort.order}` : "";
  useEffect(() => {
    setPage(1);
  }, [filtersKey, sortKey]);

  const {
    data: users,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useUsersList({
    ...filters.queryParams,
    sortBy: sort?.field,
    sortOrder: sort?.order,
    page,
    limit,
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col">
          <p className="text-[22px] font-bold text-ui-primary">Usuários Administrativos</p>
          <p className="text-[14px] text-ui-text-muted">Equipe da POUPenergia com acesso ao Painel Administrativo</p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row">
          {canUserSee(AdminUserRole.ADMIN) && (
            <Button label="Cadastrar Usuário" route={ROUTES.USERS.ADD} icon={<PlusIcon />} className="w-full sm:w-auto" />
          )}
        </div>
      </div>

      <UsersTotalizers data={totalizers} isLoading={isTotalizersLoading} />

      <UsersFilterBar filters={filters} sort={sort} onSortChange={setSort} />

      <UsersList
        data={users}
        isLoading={isUsersLoading}
        isFetching={isUsersFetching}
        limit={limit}
        onChangePage={setPage}
        onChangePageSize={setPageSize}
      />
    </div>
  );
};

export default Users;
